export const defineFloat = (input, defaultValue) => {
  const nextInput = parseFloat(input);
  return Number.isNaN(nextInput) ? defaultValue : nextInput;
};
